<div class="px-3 py-1">
    <div class="type-list py-3">
        <div class="d-flex align-items-start justify-content-between c-pointer">
            <div class="service-type d-flex align-items-center">
                <img [src]=" driverDetails.imageUrl ? helper.IMAGE_URL + driverDetails.imageUrl : helper.DefaultImages.DefaultUserImage"
                    alt="driver-profile" class="driver-image" (error)="handleImageError($event)">
                <div class="type-name ms-3">
                    @if(driverDetails.status == helper.DriverStatus.IN_BOOKING && driverDetails.bookingDetails[0]){
                    <p class="mb-0 text-dark-color">TRIP NO {{driverDetails.bookingDetails}}</p>
                    }
                    <h6 class="mb-0">{{driverDetails.firstName}} {{driverDetails.lastName}}</h6>
                    <p class="mb-0 text-dark-color">{{driverDetails.vehicleTypeDetail?.name | translatedName :
                        helper.cuurentLang}} {{
                        driverDetails.vehicleTypeDetail ?
                        "|" : ""}} {{driverDetails.vehicleDetail?.color}} | {{driverDetails.vehicleDetail?.name}} |
                        {{driverDetails.vehicleDetail?.plateNo}}</p>
                    <!-- <p class="mb-0 active-time text-info mt-1"> <svg xmlns="http://www.w3.org/2000/svg" width="18"
                            height="16" viewBox="0 0 18 16" class="me-2 mb-1" fill="none">
                            <path
                                d="M1.616 16C1.15533 16 0.771 15.846 0.463 15.538C0.155 15.23 0.000666667 14.8453 0 14.384V4.616C0 4.15534 0.154333 3.771 0.463 3.463C0.771667 3.155 1.15567 3.00067 1.615 3H6V1.615C6 1.155 6.15433 0.770669 6.463 0.462002C6.77167 0.153335 7.156 -0.000664511 7.616 2.15517e-06H10.385C10.845 2.15517e-06 11.2293 0.154002 11.538 0.462002C11.8467 0.770002 12.0007 1.15434 12 1.615V3H16.385C16.845 3 17.229 3.15434 17.537 3.463C17.845 3.77167 17.9993 4.156 18 4.616V14.385C18 14.845 17.8457 15.2293 17.537 15.538C17.2283 15.8467 16.8443 16.0007 16.385 16H1.616ZM7 3H11V1.615C11 1.46167 10.936 1.32067 10.808 1.192C10.68 1.06334 10.539 0.999335 10.385 1H7.615C7.46167 1 7.32067 1.064 7.192 1.192C7.06333 1.32 6.99933 1.461 7 1.615V3Z"
                                fill="currentColor" />
                        </svg> Working 07:00 hrs - 17:00 hrs</p> -->
                </div>
            </div>
            <div class="ratings">
                <span class="badge"> <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 9 9"
                        fill="none" style="margin-top: -2px;">
                        <path
                            d="M3.43234 2.028C3.90747 1.176 4.14484 0.75 4.49997 0.75C4.85509 0.75 5.09247 1.176 5.56759 2.028L5.69059 2.2485C5.82559 2.49075 5.89309 2.61187 5.99809 2.69175C6.10309 2.77162 6.23434 2.80125 6.49684 2.8605L6.73534 2.9145C7.65784 3.12337 8.11872 3.22762 8.22859 3.5805C8.33809 3.933 8.02384 4.30087 7.39497 5.03625L7.23222 5.22637C7.05372 5.43525 6.96409 5.53987 6.92397 5.66887C6.88384 5.79825 6.89734 5.93775 6.92434 6.21637L6.94909 6.47025C7.04397 7.45162 7.09159 7.94212 6.80434 8.16C6.51709 8.37825 6.08509 8.17912 5.22184 7.78162L4.99797 7.67887C4.75272 7.56562 4.63009 7.50937 4.49997 7.50937C4.36984 7.50937 4.24722 7.56562 4.00159 7.67887L3.77847 7.78162C2.91484 8.17912 2.48284 8.37787 2.19597 8.16037C1.90834 7.94212 1.95597 7.45162 2.05084 6.47025L2.07559 6.21675C2.10259 5.93775 2.11609 5.79825 2.07559 5.66925C2.03584 5.53987 1.94622 5.43525 1.76772 5.22675L1.60497 5.03625C0.976091 4.30125 0.661841 3.93337 0.771341 3.5805C0.881216 3.22762 1.34247 3.123 2.26497 2.9145L2.50347 2.8605C2.76559 2.80125 2.89647 2.77162 3.00184 2.69175C3.10684 2.61187 3.17434 2.49075 3.30934 2.2485L3.43234 2.028Z"
                            fill="white" />
                    </svg> {{(driverDetails?.rate).toFixed(helper.fixedNumber)}}</span>
            </div>
        </div>
    </div>
    <div class="details-view">
        <div class="d-flex">
            <div class="pe-3">
                <p class="mb-1 font-weight-medium">Distance</p>
                <h4>4.59 Km</h4>
            </div>
            <div class="px-3">
                <p class="mb-1 font-weight-medium">Min Fare</p>
                <h4>$ 145.52</h4>
            </div>
            <div class="ps-3">
                <p class="mb-1 font-weight-medium">Payment</p>
                <h4>Card</h4>
            </div>
        </div>

        <div class="ride-timeline mt-4">
            <div class="ps-5 timeline">
                <div class="py-3 line-dot">
                    <h5 class="mb-1">New Request (James Thomas)</h5>
                    <p class="mb-0">09 July 2024, 16:18 </p>
                </div>
                <div class="py-3 line-dot">
                    <h5 class="mb-1">Accepted (ASAP)</h5>
                    <p class="mb-0">09 July 2024, 16:20 </p>
                </div>
                <div class="py-3 line-dot">
                    <h5 class="mb-1">Reached at pickup</h5>
                    <p class="mb-0">09 July 2024, 16:30 </p>
                </div>
                <div class="pt-3 line-dot last">
                    <h5 class="mb-1">Started Trip</h5>
                    <p class="mb-0">09 July 2024, 16:32 </p>
                </div>
            </div>
        </div>
    </div>
</div>